module.exports = __webpack_public_path__ + "media/images/smart_phone/btn_top-035ec99757e200e6dd780269094a1387.png";